import { assign } from 'lodash';
import { RouterParams } from '../utils/routerUtility/RouterParams';
import { CLIENT_TYPE } from '../constants/auth/clientType';
const EventEmitter = require('events').EventEmitter;

var SessionTokenStorage = window.sessionStorage;
var LocalTokenStorage = window.localStorage;

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

const routerParams = new RouterParams();

const CHANGE_EVENT = 'change';
const ACT_AS_SIGN_OUT_EVENT = 'actAsSignOut';
const LOGOUT_EVENT = 'logout';

var TOKEN_KEY = 'token';
var TOKEN_ORIGINAL_KEY = 'token_original';

var errorHelper = require('../helper/error-helper');

var _token = {
  ".expires": null,
  ".issued": null,
  "access_token": null,
  "as:client_id": null,
  "expires_in": null,
  "token_type": null,
  "userName": null,
  "organisationId": null
};

var _originalToken = {
  ".expires": null,
  ".issued": null,
  "access_token": null,
  "as:client_id": null,
  "expires_in": null,
  "token_type": null,
  "userName": null,
  "organisationId": null
};

var _isSsoChecking = false,
  _is2bapExternalChecking = false,
  _isActAsChecking = false;

try {
  if (!routerParams.hasExternalToken) {
    const tokenFromLocalStorage = JSON.parse(LocalTokenStorage.getItem(TOKEN_KEY));
    if (tokenFromLocalStorage) {
      SessionTokenStorage.setItem(TOKEN_KEY, JSON.stringify(tokenFromLocalStorage));
      LocalTokenStorage.removeItem(TOKEN_KEY);
    }

    const originalTokenFromLocalStorage = JSON.parse(LocalTokenStorage.getItem(TOKEN_ORIGINAL_KEY));
    if (originalTokenFromLocalStorage) {
      SessionTokenStorage.setItem(TOKEN_ORIGINAL_KEY, JSON.stringify(tokenFromLocalStorage));
      LocalTokenStorage.removeItem(TOKEN_ORIGINAL_KEY);
    }
  }
} catch (e) { }

try {
  if (!routerParams.hasExternalToken) {
    var tokenFromStorage = JSON.parse(SessionTokenStorage.getItem(TOKEN_KEY));
    if (tokenFromStorage) {
      assign(_token, tokenFromStorage);
    }

    var tokenFromStorage = JSON.parse(SessionTokenStorage.getItem(TOKEN_ORIGINAL_KEY));
    if (tokenFromStorage) {
      assign(_originalToken, tokenFromStorage);
    }
  }
} catch (err) {

}

var AuthenticationStore = assign({}, EventEmitter.prototype, {
  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function (error) {
    this.emit(CHANGE_EVENT, error || null);
  },

  addActAsSignOutListener: function (callback) {
    this.on(ACT_AS_SIGN_OUT_EVENT, callback);
  },

  removeActAsSignOutListener: function (callback) {
    this.removeListener(ACT_AS_SIGN_OUT_EVENT, callback);
  },

  isWebClient() {
    return CLIENT_TYPE.isWeb(_token);
  },
  
  isWebViewClient() {
    return CLIENT_TYPE.isWebView(_token);
  },
  
  shouldLogoutOnTimeout() {
    return CLIENT_TYPE.shouldLogoutOnTimeout(_token);
  },

  emitActAsSignOut: function (error) {
    this.emit(ACT_AS_SIGN_OUT_EVENT, error || null);
  },

  addLogoutListener: function (callback) {
    this.on(LOGOUT_EVENT, callback);
  },

  removeLogoutListener: function (callback) {
    this.removeListener(LOGOUT_EVENT, callback);
  },

  emitLogout: function (error) {
    this.emit(LOGOUT_EVENT, error || null);
  },

  getToken: function () {
    return _token;
  },

  getAuthorizationValue() {
    return this.isLoggedIn()
      ? [_token.token_type, _token.access_token].join(" ")
      : null;
  },

  getRefreshToken(){
    var refreshToken = this.isLoggedIn()
      ? _token.refresh_token
      : null;
    return refreshToken;
  },

  getAccessToken(){
    return this.isLoggedIn()
      ? _token.access_token
      : null
  },

  getOrganisationId(){
    return this.isLoggedIn()
      ? _token.organisationId
      : null
  },

  getError: function () {
    return _error.message;
  },

  getSsoCheckingStatus: function () {
    return _isSsoChecking;
  },

  getActAsCheckingStatus: function () {
    return _isActAsChecking;
  },

  get2bapExternalCheckingStatus: function () {
    return _is2bapExternalChecking;
  },

  set2bapExternalCheckingStatus: function (status) {
    _is2bapExternalChecking = status;
  },

  isLoggedIn: function () {
    return !!_token.access_token;
  },

  logout(isActAsMode){
    this._destroyTokenInternal(_token, TOKEN_KEY);

    if (!!isActAsMode) {
      if (!_originalToken) return;
      this._destroyTokenInternal(_originalToken, TOKEN_ORIGINAL_KEY);
    }
  },

  logoutActAs(cb){
    this._destroyTokenInternal(_token, TOKEN_KEY);

    if (!_originalToken) return;
    this.saveToken(_originalToken);

    if (cb) {
      cb(_originalToken);
    }

    this._destroyTokenInternal(_originalToken, TOKEN_ORIGINAL_KEY);
  },

  _destroyTokenInternal(token, tokenKeyInStorage) {
    for (var i in token) {
      if (!token.hasOwnProperty(i)) continue;
      token[i] = null;
    }
    SessionTokenStorage.removeItem(tokenKeyInStorage);
  },

  saveToken(token){
    assign(_token, token);
    SessionTokenStorage.setItem(TOKEN_KEY, JSON.stringify(token));
  },

  saveTokenToLocalStorage() {
    LocalTokenStorage.setItem(TOKEN_KEY, JSON.stringify(_token));
    LocalTokenStorage.setItem(TOKEN_ORIGINAL_KEY, JSON.stringify(_originalToken));
  },

  actAs() {
    assign(_originalToken, _token);
    SessionTokenStorage.setItem(TOKEN_ORIGINAL_KEY, JSON.stringify(_originalToken));
  },

});

Dispatcher.register(function (action) {
  switch (action.actionType) {
    case ActionType.AUTH_LOGIN:
      AuthenticationStore.saveToken(action.token);
      _isSsoChecking = false;
      AuthenticationStore.emitChange();
      break;
    case ActionType.AUTH_LOGOUT :
      AuthenticationStore.logout(action.isActAsMode);
      AuthenticationStore.emitChange();
      AuthenticationStore.emitLogout();
      break;
    case ActionType.AUTH_LOGOUT_ACT_AS:
      AuthenticationStore.logoutActAs(action.cb);
      AuthenticationStore.emitActAsSignOut();
      AuthenticationStore.emitChange();
      AuthenticationStore.emitLogout();
      break;
    case ActionType.AUTH_ACT_AS:
      AuthenticationStore.actAs();
      AuthenticationStore.emitChange();
      break;
    case ActionType.AUTH_LOGIN_2BAP_EXTERNAL_START:
      AuthenticationStore.set2bapExternalCheckingStatus(true);
      AuthenticationStore.emitChange();
      break;
    case ActionType.AUTH_LOGIN_2BAP_EXTERNAL_END:
      AuthenticationStore.set2bapExternalCheckingStatus(false);
      if (action.error) {
        AuthenticationStore.emitChange(errorHelper.GetActionError(action.actionType, action.error));
      }
      AuthenticationStore.emitChange();
      break;
    case ActionType.AUTH_LOGIN_FAILURE:
      AuthenticationStore.emitChange(errorHelper.GetActionError(action.actionType, action.error));
      break;
    case ActionType.AUTH_LOGIN_SSO_FAILURE:
      _isSsoChecking = false;
      AuthenticationStore.emitChange(errorHelper.GetActionError(action.actionType, action.error));
      break;
    case ActionType.AUTH_LOGIN_ACT_AS_FAILURE:
      _isActAsChecking = false;
      AuthenticationStore.emitChange(errorHelper.GetActionError(action.actionType, action.error));
      break;

    default:
      break;
  }
});


module.exports = AuthenticationStore;
